// src/pages/admin/DashboardHeader.js
import React from 'react';
import { Layout, Typography, Button, Dropdown, Menu, Avatar } from 'antd';
import { UserOutlined, MenuOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Header } = Layout;
const { Title, Text } = Typography;

const DashboardHeader = ({ showDrawer, loggedInUser }) => {
  const navigate = useNavigate();

  const userMenu = (
    <Menu>
      <Menu.Item key="profile" onClick={() => navigate('/admin/profile')}>Profile</Menu.Item>
      <Menu.Item key="logout" onClick={() => { localStorage.removeItem('userRole'); navigate('/signin'); }}>Logout</Menu.Item>
    </Menu>
  );

  return (
    <Header style={{ padding: '0 16px', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Button type="text" icon={<MenuOutlined />} onClick={showDrawer} style={{ marginRight: 16, display: window.innerWidth < 768 ? 'block' : 'none' }} />
        <Title level={3} style={{ margin: 0, fontSize: window.innerWidth < 768 ? '16px' : '20px' }}>Admin Dashboard</Title>
      </div>
      <Dropdown overlay={userMenu} trigger={['hover']}>
        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
          <Avatar icon={<UserOutlined />} style={{ marginRight: window.innerWidth < 768 ? 0 : 8 }} />
          <Text style={{ display: window.innerWidth < 768 ? 'none' : 'block' }}>{loggedInUser.name}</Text>
        </div>
      </Dropdown>
    </Header>
  );
};

export default DashboardHeader;